import Footer from './Footer'
import ContactInfo from './ContactInfo'

export const ContactInfoAndFooter = () => {
  return (
    <div id="contactInfoAndFooter">
      <ContactInfo />
      <Footer />
    </div>
  )
}

export default ContactInfoAndFooter;

